import script from "./RealEstateBrokerMemberNavbarItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./RealEstateBrokerMemberNavbarItems.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__